import type { BackendTypes } from '@tf/api';
import { TFText } from '@tf/ui';
import { S } from '@tf/utils';
import type { FC } from 'react';

interface Props {
	accountStatus: BackendTypes.OverviewAccountStatus | undefined;
}

const colors: Record<BackendTypes.OverviewAccountStatus, string> = {
	PROSPECT: 'brand',
	ACTIVE: 'green',
	SUSPENDED: 'orange',
	REJECTED: 'red',
	CLOSED: 'red',
	ARCHIVED: 'grey',
};

export const AccountStatus: FC<Props> = ({ accountStatus }) => {
	const status = accountStatus || 'PROSPECT';
	return (
		<TFText inherit c={colors[status]}>
			{S.prettify(status)}
		</TFText>
	);
};
